import { FC } from 'react';
import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EngagementSurveyDto, SurveyAnswerDto } from '@families-link/shared';
import { useGetSurveyUnrecognizedAnswersQuery } from '../../../../store/api/survey.api';
import { UnrecognizedSurveyAnswersTable } from './families-details-table/families-unrecognized-answers-table.component';

interface FamilyDetailsListProps {
	engagementSurvey?: EngagementSurveyDto;
	handleOpenDeleteSurveyAnswerConfirmModal: any;
	handleOpenModalAttachFamily: any;
	setCurrentUnrecognizedAnswer: any;
	setResultComponent: any;
}

export const UnrecognizedAnswersComponent: FC<FamilyDetailsListProps> = (props) => {
	const {
		engagementSurvey,
		setCurrentUnrecognizedAnswer,
		setResultComponent,
		handleOpenModalAttachFamily,
		handleOpenDeleteSurveyAnswerConfirmModal,
	} = props;

	const {
		data: unrecognizedAnswers,
		isFetching: isUnrecognizedAnswersFetching,
	} = useGetSurveyUnrecognizedAnswersQuery({ surveyId: engagementSurvey?._id }, { skip: !engagementSurvey });

	const [t] = useTranslation();

	const handleOnViewUnrecognizedAnswer = async (surveyAnswer?: SurveyAnswerDto) => {
		setCurrentUnrecognizedAnswer(surveyAnswer);
		setResultComponent('unrecognized');
	};

	return unrecognizedAnswers?.length ? (
		<Paper elevation={0} sx={{ maxHeight: '311px', display: 'flex', flexDirection: 'column', gap: '24px', p: '24px' }}>
			<Typography variant="h6" sx={{ fontWeight: 500, fontSize: '16px' }}>
				{t('surveys.unrecognized-survey-answers')}
			</Typography>

			<UnrecognizedSurveyAnswersTable
				data={unrecognizedAnswers ?? []}
				loading={isUnrecognizedAnswersFetching}
				onAttachFamily={handleOpenModalAttachFamily}
				onDelete={handleOpenDeleteSurveyAnswerConfirmModal}
				onView={handleOnViewUnrecognizedAnswer}
			/>
		</Paper>
	) : null;
};
